'use client'

import { AppWrapper } from '~/components/app-wrapper'
import { InvoicesPage } from '~/domains/account/components/invoices/invoices-page'

export const Page = () => (
	<AppWrapper className='max-md:pb-[60px]'>
		<InvoicesPage />
	</AppWrapper>
)
